var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-text-field', {
    staticClass: "mt-4 white medium-density inline-error",
    attrs: {
      "outlined": "",
      "persistent-placeholder": "",
      "label": `Location name${_vm.required ? ' *' : ''}`,
      "disabled": _vm.disabled,
      "rules": [function (v) {
        return !_vm.required || !!v || 'Required';
      }, function (v) {
        return (v || '').length <= 200 || 'Too long';
      }]
    },
    model: {
      value: _vm.event.location,
      callback: function ($$v) {
        _vm.$set(_vm.event, "location", $$v);
      },
      expression: "event.location"
    }
  }), _c('v-checkbox', {
    staticClass: "mt-4 mb-0 pt-0",
    attrs: {
      "label": "Include address / map link",
      "hide-details": "",
      "disabled": _vm.disabled
    },
    model: {
      value: _vm.showAddress,
      callback: function ($$v) {
        _vm.showAddress = $$v;
      },
      expression: "showAddress"
    }
  }), _c('v-expand-transition', [_vm.showAddress ? _c('div', {
    staticClass: "ml-8"
  }, [_c('v-textarea', {
    staticClass: "mt-4 white inline-error",
    attrs: {
      "label": "Address",
      "outlined": "",
      "persistent-placeholder": "",
      "no-resize": "",
      "rows": "2",
      "disabled": _vm.disabled,
      "rules": [function (v) {
        return (v || '').length <= 500 || 'Too long';
      }]
    },
    on: {
      "input": _vm.tryAutoLink
    },
    model: {
      value: _vm.event.address,
      callback: function ($$v) {
        _vm.$set(_vm.event, "address", $$v);
      },
      expression: "event.address"
    }
  }), _c('v-checkbox', {
    staticClass: "mt-4 pt-0",
    attrs: {
      "label": "Auto-generate map link",
      "hide-details": "",
      "disabled": _vm.disabled || !_vm.event.address,
      "input-value": !!_vm.event.address && _vm.autoLink
    },
    on: {
      "change": function (v) {
        _vm.autoLink = v;
        _vm.tryAutoLink();
      }
    }
  }), _c('v-text-field', {
    key: "map-link",
    staticClass: "mt-4 white inline-error",
    attrs: {
      "outlined": "",
      "persistent-placeholder": "",
      "placeholder": "http…",
      "label": "Map link",
      "disabled": _vm.disabled,
      "rules": [_vm.validateURL]
    },
    on: {
      "input": function ($event) {
        _vm.autoLink = false;
      }
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function () {
        return [_c('v-btn', {
          attrs: {
            "color": "primary",
            "icon": "",
            "target": "_blank",
            "disabled": !_vm.event.url_map || _vm.validateURL(_vm.event.url_map) != true,
            "href": _vm.event.url_map
          },
          on: {
            "click": function ($event) {
              return _vm.openURL(_vm.event.url_map);
            }
          }
        }, [_c('v-icon', {
          domProps: {
            "innerHTML": _vm._s(_vm.mdiOpenInNew)
          }
        })], 1)];
      },
      proxy: true
    }], null, false, 4162937851),
    model: {
      value: _vm.event.url_map,
      callback: function ($$v) {
        _vm.$set(_vm.event, "url_map", $$v);
      },
      expression: "event.url_map"
    }
  })], 1) : _vm._e()]), _c('v-checkbox', {
    staticClass: "mt-4 mb-0 pt-0",
    attrs: {
      "label": "Include virtual event link",
      "hide-details": "",
      "disabled": _vm.disabled
    },
    model: {
      value: _vm.showVirtual,
      callback: function ($$v) {
        _vm.showVirtual = $$v;
      },
      expression: "showVirtual"
    }
  }), _c('v-expand-transition', [_vm.showVirtual ? _c('div', {
    staticClass: "ml-8"
  }, [_c('v-text-field', {
    key: "virtual-event-link",
    staticClass: "mt-4 white inline-error",
    attrs: {
      "outlined": "",
      "persistent-placeholder": "",
      "placeholder": "http…",
      "label": "Virtual event link *",
      "disabled": _vm.disabled,
      "rules": [function (v) {
        return !!v || 'Required';
      }, _vm.validateURL]
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function () {
        return [_c('v-btn', {
          staticClass: "mr-n1",
          attrs: {
            "color": "primary",
            "icon": "",
            "target": "_blank",
            "disabled": !_vm.event.url_virtual || _vm.validateURL(_vm.event.url_virtual) != true,
            "href": _vm.event.url_virtual
          },
          on: {
            "click": function ($event) {
              return _vm.openURL(_vm.event.url_virtual);
            }
          }
        }, [_c('v-icon', {
          domProps: {
            "innerHTML": _vm._s(_vm.mdiOpenInNew)
          }
        })], 1)];
      },
      proxy: true
    }], null, false, 2276662678),
    model: {
      value: _vm.event.url_virtual,
      callback: function ($$v) {
        _vm.$set(_vm.event, "url_virtual", $$v);
      },
      expression: "event.url_virtual"
    }
  })], 1) : _vm._e()])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }